//@flow
import * as React from 'react';
import { ConfirmationDialog } from 'common/components/core/dialog/ConfirmationDialog';

import { dashboardColors } from 'common/enums/ColorEnum';
import { translate } from 'react-i18next';

class DeleteConfirmationDialog extends React.PureComponent {
    onAccept = () => {
        const { onDelete, selectedRows } = this.props;
        onDelete([selectedRows]);
    };
    render() {
        const {
            active,
            onCancel,
            theme,
            title,
            innerText,
            isLoading,
            t
        } = this.props;
        return (
            <ConfirmationDialog
                active={active}
                isLoading={isLoading}
                title={title}
                theme={theme}
                onAccept={this.onAccept}
                onCancel={onCancel}
                acceptActionLabel={t('zoneMap.delete')}
                acceptActionColor={dashboardColors.salmonTwo.name}
                innerText={innerText}
            />
        );
    }
}
const TranslatedDeleteConfirmationDialog = translate('entityManagement')(
    DeleteConfirmationDialog
);
export { TranslatedDeleteConfirmationDialog as DeleteConfirmationDialog };
export default TranslatedDeleteConfirmationDialog;
